import { controls,grouped } from "../controls";
const sprint_storys = {
label: "Sprint Storys",
pageLabel: "Sprint Storys",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
...controls.displayText({ tab: "filter", label: "User"}),
...controls.oc({ tab: "filter", c: "User", placeHolder: "User Code", name: "SprintStory-developer-user_code",fastpath: "users"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "SprintStory-developer-user_display"}),
...controls.displayText({ tab: "filter", label: "Story"}),
...controls.oc({ tab: "filter", c: "Story", placeHolder: "Story Code", name: "SprintStory-story-story_code",fastpath: "storys"}),
...controls.showData({ tab: "filter", displaytype: "capital", data: "SprintStory-story-story_display"}),
...controls.displayText({ tab: "filter", label: "Work Status"}),
...controls.autoComplete({tab: "filter", name: "SprintStory-work_status-work_status_code", width: "col-sm-2",controlType: "WorkStatus"}),
...controls.displayText({ tab: "filter", label: ""}),
]
,form:[
...controls.displayText({ tab: "general", label: "Story",star:true}),
...controls.oc({ tab: "general", c: "Story", placeHolder: "Story Code", name: "story_code",isRequired:true,fastpath: "storys",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "story_display"}),
...controls.displayText({ tab: "general", label: "Priority",star:false}),
...controls.numberOnly({ tab: "general",  placeHolder: "", name: "priority",maxlength:200}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Remark",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "remark",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "general", label: "User",star:false}),
...controls.oc({ tab: "general", c: "User", placeHolder: "User Code", name: "user_code",fastpath: "users",hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "user_display"}),
...controls.displayText({ tab: "general", label: "Log Work"}),
...controls.floatOnly({ tab: "general",  placeHolder: "", name: "log_work",maxlength:6}),
...controls.displayText({ tab: "general", label: ""}),
...controls.displayText({ tab: "general", label: "Replicate With Data",star:false}),
...controls.text({ tab: "general",  placeHolder: "", name: "replicate_with_data",width:"col-sm-4",maxlength:200}),
...controls.displayText({ tab: "general", label: "Work Status",star:false}),
...controls.autoComplete({tab: "general", name: "work_status_code", width: "col-sm-2",controlType: "WorkStatus"}),
...controls.displayText({ tab: "general", label: ""}),
]
,history:{
perPage: 10,
reportHeader: "Sprint Storys",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "User",accessor: "SprintStory-developer-user_display",},
{Header: "Story",accessor: "SprintStory-story-story_display",},
{Header: "Priority",accessor: "priority",},
{Header: "Remark",accessor: "remark",},
{Header: "Log Work",accessor: "log_work",},
{Header: "Work Status",accessor: "SprintStory-work_status-work_status_display",},
]}};
export default sprint_storys;